import { render, staticRenderFns } from "./PPCMInputDelivery.vue?vue&type=template&id=4f07f5fc&scoped=true&"
import script from "./PPCMInputDelivery.vue?vue&type=script&lang=js&"
export * from "./PPCMInputDelivery.vue?vue&type=script&lang=js&"
import style0 from "../Inspection/PPCMInputInspection.scss?vue&type=style&index=0&id=4f07f5fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f07f5fc",
  null
  
)

export default component.exports